var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KChip',{attrs:{"medium":_vm.medium,"icon":"mdi-clock-outline","title":_vm._f("dateFullBR")(_vm.date)}},[_vm._v(_vm._s(_vm._f("timeAgoFull")(_vm.date)))])
}
var staticRenderFns = []

export { render, staticRenderFns }